import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { dispatchHandler } from "../helper/apiHelperFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { parseJwt } from "../helper/genericFunction";
import { v4 as uuidv4 } from 'uuid';
import { getPermissionKey } from "../helper/permissions";

// Registry — add new actions here in future without changing the page
const ACTION_REGISTRY = {
    APPROVE_ORDER: {
        endpoint: '/api/purchase/order/approve-via-token',
        method: 'POST',
        label: 'Order Approval',
        status: 'APPROVED',
    },
    REJECT_ORDER: {
        endpoint: '/api/purchase/order/approve-via-token',
        method: 'POST',
        label: 'Order Rejection',
        status: 'REJECTED',
    }
};

const ActionPage = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const digiProcStore = useSelector(state => state.digiProcStore)

    const urlSearchParams = new URLSearchParams(location.search), 
    params = Object.fromEntries(urlSearchParams.entries());

    const [status, setStatus] = useState("processing");
    const [meta, setMeta] = useState({ label: "Action", details: "" });
    const [message, setMessage] = useState("");

    console.log("thissdfsdfsdf", params);

    useEffect(() => {
        const token = decodeURIComponent?.(params?.token)?.replace?.(/^"|"$/g, ''); 
        if (!token) return setStatus?.("error");

        const decoded = JSON.parse(decodeURIComponent?.(params?.payload));

        console.log("this is the decode", decoded)

        const documentNumbers = Array.isArray(decoded?.documentNumbers)
        ? decoded.documentNumbers
        : [decoded?.documentNumbers].filter(Boolean);


        const actionType = params?.action || (location.pathname.includes('rejectOrder') ? 'REJECT_ORDER' : 'APPROVE_ORDER');
        const actionConfig = ACTION_REGISTRY[actionType];
        if (!actionConfig) {
            setStatus("error");
            setMessage("Unknown action type.");
            return;
        }

        setMeta({
            label: actionConfig.label,
            details: documentNumbers.join(", "),
        });

        executeAction(token, { ...decoded, documentNumbers }, actionConfig);
    }, []);

    useEffect(() => {
        if (digiProcStore?.po_approve_rejectData?.isSuccess) {
            sessionStorage.removeItem("X-REQUEST-ID");
            setStatus("success");
            setMessage(`${meta.label} completed successfully!`);
            setTimeout(() => {
                window.close();
            }, 2000);
        }
        else if(digiProcStore?.po_approve_rejectData?.isError) {
            sessionStorage.removeItem("X-REQUEST-ID");
            setStatus("error");
            setMessage(digiProcStore?.po_approve_rejectData?.message?.errorMessage || "");
        }
    }, [digiProcStore?.po_approve_rejectData?.isSuccess, digiProcStore?.po_approve_rejectData?.isError])

    const executeAction = async (token, decoded, config) => {
        let tokenData = parseJwt(sessionStorage?.getItem("token"));
        sessionStorage.setItem("X-REQUEST-ID", uuidv4() + (tokenData.jti || ""));

        const documentNumbers = Array.isArray(decoded?.documentNumbers)
        ? decoded.documentNumbers
        : [decoded?.documentNumbers].filter(Boolean);
        let payload = {
            documentNumbers: documentNumbers,
            status: config.status,
            remark: ''
        }
        dispatchHandler(dispatch, 'po_approve_rejectRequest', payload, {...getPermissionKey("purchase", "order", "approve"), "X-Auth-Token": token});
    };

    return (
        <div style={styles.container}>
            {status === "processing" && (
                <div style={styles.card}>
                    <div style={styles.spinner} />
                    <h2>Processing {meta.label}...</h2>
                    <p>Please wait while we process your request.</p>
                </div>
            )}

            {status === "success" && (
                <div style={{ ...styles.card, borderTop: "4px solid #28a745" }}>
                    <div style={styles.icon}>✅</div>
                    <h2 style={{ color: "#28a745" }}>{meta.label} Successful!</h2>
                    <p>{message}</p>
                    <small>This tab will close automatically...</small>
                </div>
            )}

            {status === "expired" && (
                <div style={{ ...styles.card, borderTop: "4px solid #ffc107" }}>
                    <div style={styles.icon}>⏰</div>
                    <h2 style={{ color: "#ffc107" }}>Link Expired</h2>
                    <p>{message}</p>
                    <p>Please log in to the portal to action manually.</p>
                </div>
            )}

            {status === "error" && (
                <div style={{ ...styles.card, borderTop: "4px solid #dc3545" }}>
                    <div style={styles.icon}>❌</div>
                    <h2 style={{ color: "#dc3545" }}>{meta.label} Failed</h2>
                    <p>{message}</p>
                </div>
            )}
        </div>
    )
};

const styles = {
    container: {
        minHeight: "100vh", display: "flex",
        alignItems: "center", justifyContent: "center",
        background: "#f5f5f5", fontFamily: "sans-serif"
    },
    card: {
        background: "white", padding: "48px",
        borderRadius: "12px", textAlign: "center",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        maxWidth: "480px", width: "100%"
    },
    icon: { fontSize: "48px", marginBottom: "16px" },
    spinner: {
        width: "40px", height: "40px", margin: "0 auto 16px",
        border: "4px solid #f0f0f0",
        borderTop: "4px solid #007bff",
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    }
};

export default ActionPage;